import FeaturePageTemplate from "@/components/FeaturePageTemplate";

export default function AiVoicePage() {
  return (
    <FeaturePageTemplate
      slug="voice"
      accent="#7C3AED"
      badge="Nextiva-adjacent · Now available"
      title="AI Voice & Communication Platform"
      tagline="One brain across chat, voice, phone, SMS & WhatsApp"
      subtitle="A unified communications hub built for grounded AI conversations. Handle inbound and outbound voice, missed-call recovery, live-agent copilot, and browser voice — all from a single knowledge vault, with consent and audit built-in."
      primaryCta={{ label: "Open Voice Hub", to: "/voice" }}
      secondaryCta={{ label: "Build your AI Employee", to: "/build-agent" }}
      brandStripe="Every voice representative discloses that it is AI. Voice cloning requires signed, revocable consent. Audio processed in memory — not stored."
      flow={[
        { n: "1", title: "Ingest knowledge",   desc: "Approve website + docs into the WTC vault — the single source of truth." },
        { n: "2", title: "Configure persona",  desc: "Voice, tone, restricted topics, allowed actions, industry template." },
        { n: "3", title: "Publish to channels", desc: "Web widget, voice, phone, SMS, WhatsApp — one brain across all." },
        { n: "4", title: "Recover & assist",   desc: "Missed calls auto-recover; Copilot whispers next best action to humans." },
        { n: "5", title: "Measure & improve",  desc: "Every conversation scored for grounding, sentiment, and outcome." },
      ]}
      capabilities={[
        { icon: "Mic",       title: "Browser voice widget",       desc: "Whisper transcribes; OpenAI TTS speaks back. Works on any device with a mic." },
        { icon: "Phone",     title: "Telephone answering",        desc: "Real inbound and outbound calls (Twilio-compatible), transcripts + summaries auto-filed." },
        { icon: "PhoneMissed", title: "Missed-call recovery",     desc: "Auto SMS/WhatsApp with a callback link. Configurable delay, quiet hours, max attempts." },
        { icon: "Zap",       title: "Employee Copilot",           desc: "Grounded reply drafts and next-best-action for your human team — never sends on its own." },
        { icon: "MessageCircle", title: "SMS + WhatsApp",         desc: "Same brain, same guardrails, same permissions across every text channel." },
        { icon: "ShieldCheck", title: "Consent + AI disclosure",  desc: "AI notice on every channel. Voice/likeness cloning requires signed consent." },
      ]}
      safetyBullets={[
        ["No card data in chat", "Payment assistance uses secure links only — the AI never sees or stores card numbers."],
        ["Restricted-topic guardrails", "Medical / legal / financial → disclaimer + human handoff by policy."],
        ["PII redaction", "Emails, phones, cards, SSN patterns masked in stored transcripts."],
        ["Session caps + rate limits", "Runaway conversations and abuse are automatically throttled."],
      ]}
      closingHeadline="Bring every channel into one intelligent conversation."
      closingSubtitle="Wire up your first channel in minutes. Add the rest as you grow."
      testIdPrefix="ai-voice-page"
    />
  );
}
